import { OptimizationType, RoutingType } from "./routing-request";
import {TaskStatus} from "./task-status";

export interface BasicInfo {
  totalTime: number;
  workTime: number;
  travelTime: number;
  distance: number;
  numTask: number;
}

export interface UnassignedTask {
  taskName: string;
  pickUpPlace: {
    placeName: string;
    road: string;
    latitude: number;
    longitude: number;
  };
  pickUpTimeWindow: {
    startTimeLimited: Date;
    endTimeLimited: Date;
  };
  pickUpServiceTime: number;
  dropOffPlace: {
    placeName: string;
    road: string;
    latitude: number;
    longitude: number;
  };
  dropOffTimeWindow: {
    startTimeLimited: Date;
    endTimeLimited: Date;
  };
  dropOffServiceTime: number;
  capacity: number;
}

export enum TaskType {
  Start = "START",
  PickUp = "PICK_UP",
  DropOff = "DROP_OFF",
  End = "END",
}

export const isStartOrPickUp = (taskType: TaskType): boolean => {
  return taskType === TaskType.Start || taskType === TaskType.PickUp;
};

export interface TaskSequence {
  taskName: string;
  taskType: TaskType;
  placeName: string;
  arrivalTime: Date;
  serviceTime: number;
  intervalTime: number;
  completeTime: Date;
  distance: number;
  status: TaskStatus;
}

export interface RoutingSummary {
  routingType: RoutingType;
  optimizationType: OptimizationType;
  basicInfo: BasicInfo;
  unassignedTasks: UnassignedTask[];
}

export interface VehicleResult {
  vehicleName: string;
  basicInfo: BasicInfo;
  polyline?: string;
  taskSequences: TaskSequence[];
}

export interface RoutingResponse {
  routingSummary: RoutingSummary;
  vehicleResults: VehicleResult[];
}
